import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import "./about.css";
import Rocket from "../../images/Rocket.svg";

const About = () => {
  const fadeRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <div className="about" id="about">
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        About Page
      </motion.h1>
      <div className="about-content">
        <div className="about__left">
          <motion.img
            className="rocket-img"
            whileTap={{ scale: 0.6 }}
            drag={true}
            dragConstraints={{ left: 0, right: 250, top: 0, bottom: 50 }}
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 1 } }}
            src={Rocket}
            alt="rocket"
          />
        </div>
        <div className="about__right">
          <motion.p
            variants={fadeRight}
            initial="hidden"
            animate="visible"
            transition={{ duration: 1 }}
            className="para-header"
          >
            Our galaxy, the Milky Way, is typical
          </motion.p>
          <motion.p
            className="paragraph"
            variants={fadeRight}
            initial="hidden"
            animate="visible"
            transition={{ duration: 1 }}
          >
            it has hundreds of billions of stars, enough gas and dust to make
            billions more stars, and at least ten times as much dark matter as
            all the stars and gas put together. And it’s all held together by
            gravity.
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default About;
